import { useMemo } from 'react';
import { ScoreMarkEnum } from '../../api/enums/leaderboard-enums';
import medal from '../../assets/svgs/Empty state_Leaderboard4.png';
import styles from '../LeaderBoard/styles.module.css';
import { TableData } from '../TableData';
import { TableHeaders } from '../TableHeaders';
import { BPLeaderboardPayload } from '../../api/interfaces/BPleaderboard-payload.interface';
import { useTranslation } from 'react-i18next';

interface ILeaderBoardProps {
  payload: BPLeaderboardPayload
}

export function LeaderBoard({ payload }: ILeaderBoardProps) {
  let marks;
  const { t } = useTranslation();

  const isGoAntNotEmpty = useMemo(() => {
    return payload?.isGo && payload?.items?.length > 0;
  }, [payload]);

  const isEmpty = useMemo(() => {
    return payload && payload?.items?.length < 1;
  }, [payload]);

  marks = payload.marks;
  if (!marks) {
    marks = new Array<ScoreMarkEnum>(
        ScoreMarkEnum.HITS,
        ScoreMarkEnum.TIMEOUT_MISSES,
        ScoreMarkEnum.REACTION_TIME,
        ScoreMarkEnum.STRIKES
    );
  }
  if (!marks.includes(ScoreMarkEnum.TIMED_PLAYS)) marks.push(ScoreMarkEnum.TIMED_PLAYS);
  if (!marks.includes(ScoreMarkEnum.EMPTY_ROW) && marks.length < 3) {
    marks.push(ScoreMarkEnum.EMPTY_ROW);
  }

  return (
    <div className={styles.leaderboards}>
      <TableHeaders title={payload?.title} subtitle={payload?.subtitle} marks={marks} />
      <TableData {...payload} marks={marks} />
      {isEmpty && (
        <div className={styles.blur}>
          <div className={styles.emptyStateLeaderboardParent}>
            <div className={styles.iconContainer}>
              <img className={styles.emptyStateIcon} alt='No result logo' src={medal} />
            </div>
            <b className={styles.mainText}>{t("noResultsState.contentTitle")}</b>
            <div className={styles.text}>{t("noResultsState.contentSubtitle")}</div>
          </div>
        </div>
      )}

      {isGoAntNotEmpty && (
        <div className={styles.blur}>
          <div className={styles.emptyStateLeaderboardParent}>
            <b className={styles.mainText}>{t("isGoState.contentTitle")}</b>
            <div className={styles.text}>{t("isGoState.contentSubtitle")}</div>
          </div>
        </div>
      )}
    </div>
  );
}
